import React from 'react';
import { Filter } from 'lucide-react';
import { Button } from '../ui/button';
import { distanceFilters } from './venirData';

export const DistanceFilter = ({ value, onChange, testId }) => (
  <div className="flex flex-wrap gap-2 mb-6" data-testid={testId}>
    {distanceFilters.map((filter) => (
      <Button
        key={filter.value}
        variant={value === filter.value ? "default" : "outline"}
        size="sm"
        className={`rounded-full ${value === filter.value ? 'bg-fuchsia-600 hover:bg-fuchsia-700' : ''}`}
        onClick={() => onChange(filter.value)}
      >
        <Filter className="h-3 w-3 mr-1" />
        {filter.label}
      </Button>
    ))}
  </div>
);
